import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as clevertapCapital from 'clevertap/capital';
import { CAPITAL_ALLOW_PERMISSION_PAGE } from 'utils/capitalUtils';
import styles from './Introduction.css';
import * as actCapital from '../../../actions/capital';

class Introduction extends Component {
  render() {
    const capitalBanner =
      'https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/capital/banner-introduction.png';
    return (
      <div className={`row ${styles['body-container']}`}>
        <div className={`row ${styles['row-padding']}`}>
          <div className="col-sm-7 col-md-7">
            <img
              src={capitalBanner}
              className={`${styles['capital-images']}`}
            />
          </div>
          <div className="col-sm-4 col-md-4">
            <div className={styles.title}>
              <p>Fast Loans for Moka Merchants</p>
            </div>
            <hr className={styles.line} />
            <p className={styles['body-content']}>
              Moka Capital provides fast and easy loans to help Moka merchants
              expand their business.
            </p>
            <button
              onClick={this._onClickApply}
              className={`btn btn-success btn-block ${styles['create-button']}`}
            >
              Apply for Loan <i className="fa fa-arrow-right" />
            </button>
          </div>
        </div>
      </div>
    );
  }

  _onClickApply = () => {
    const { borrowerProfile } = this.props;
    if (!borrowerProfile.allow) {
      this.props.dispatch(
        actCapital.setCapitalPage(CAPITAL_ALLOW_PERMISSION_PAGE)
      );
    } else {
      this.props.dispatch(actCapital.pageRequestResult(borrowerProfile));
    }
    clevertapCapital.capitalClickApplyForLoan();
  };
}

Introduction.propTypes = {
  goToSubscribeView: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const { borrowerProfile } = state.capital;
  return {
    borrowerProfile,
  };
}

export default connect(mapStateToProps)(Introduction);
